module.exports = __webpack_public_path__ + "img/SMARTCHECK-@2x.806f586a.png";